import React, { useState, useRef, useEffect } from "react";
import { useTranslation } from "react-i18next";
import styles from "./SimpleRaports.module.scss";
import { useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Button } from "components/index";
import "react-sliding-pane/dist/react-sliding-pane.css";
import SlidingPane from "react-sliding-pane";
import { useReactToPrint } from "react-to-print";
import TaskForm from "components/Forms/TaskForm/TaskForm";

import { setSignStatement } from "store/slices/StatementsSlice";
import { SignRaport, SignRaportFile, getRaportsChats } from "service/StatementsService";
import userInfo from "utils/userInfo";
import Notification from "utils/Notifications";

import close from "assets/icons/close.png";
import printer from "assets/icons/printer.png";
import back from "assets/icons/back.svg";
import print from "assets/icons/print.png";
import SlidingPaneUtil from "utils/SlidingPaneUtil";
import AgreementForm from "components/Forms/StatementForm/components/RaportForm/components/AgreementForm";
import DocumentHistory from "components/DocumentHistory/DocumentHistory";
import PdfPreview from "hooks/PdfPreview/PdfPreview";
import DocumentImgSigns from "components/Signs/DocumentImgSigns";
import ModalWindow from "hooks/ModalWindow/ModalWindow";
import EmployeeSelectUserId from "hooks/EmployeeSelect/EmployeeSelectUserId";
import PinCode from "hooks/PinCode/PinCode";
import { Spinner } from 'components/UnvUI'
import {
  checkPinCode,
} from "service/AuthService";
import eyeIcon from '../../../../../../../assets/icons/eye.png'
import documentIcon from 'assets/icons/copy.png'
import Task from 'assets/side_pane_new_icons/note.svg'
import FileBlock from "utils/FileBlock";
import { AddWaterMark } from "hooks/PdfWaterMark/AddWaterMark";
const SimpleRaports = ({ render,info, setRender, history }) => {
  const { t } = useTranslation("common");
  const [otkaz, setOtkaz] = useState("");
  let text = useState();
  const [isShown, setIsShown] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [newAdresseId, setNewAdresseId] = useState();
  const [selectedEmployeeLabel, setSelectedEmployeeLabel] = useState([]);
  const [state, setState] = useState({
    isPaneOpen: false,
    isPaneOpenLeft: false,
    isTask: false,
  });
  const [chats,setChats] = useState([])
  const [pinOrComment, setPinOrComment] = useState(true);
  const [menu_preview, setMenuPreview] = useState(true);
  const [menu_previewCard, setMenuPreviewCard] = useState(false);
  const [menu_previewTask, setMenuPreviewTask] = useState(false);
  const [pinCode, setPinCode] = useState("");
  const [state2, setState2] = useState({
    isPaneOpen2: false,
    isPaneOpenLeft2: false,
    isDecline: false,
    isAcquaint: false,
    isРЎhancellery: false,
  });
  const [loader, setLoader] = useState(false);

  const handleClickDecline = () => {
    setState2({ isPaneOpen2: true, isDecline: true });
  };
  const handleClickAcquainted = () => {
    setState2({ isPaneOpen2: true, isAcquaint: true });
  };
  const handleClickРЎhancellery = () => {
    setState2({ isPaneOpen2: true, isРЎhancellery: true });
  };
  const handleClickReSend = (info) => {
    setOpenModal(true);
  };

  const [width, setWidth] = useState(window.innerWidth);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const user = userInfo();

  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: `Р Р°РїРѕСЂС‚ (${info.number})`,
  });

  const [notify, setNotify] = useState({
    isOpen: false,
    message: "",
    type: "",
  });

  useEffect(() => {
    function handleResize() {
      setWidth(window.innerWidth);
    }
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [width]);
  useEffect(() => {
    width < 600 && handleSideNavToggle();
  });

  function handleSideNavToggle() {
  }


  const getChats = async () => {
    try {
      if (info?.id) {
        
        let response = await getRaportsChats(info?.id)
        setChats(response.data)
      }else{
        
      }
    } catch (error) {
      
    }
  }
  useEffect(() => {
    getChats()
    setRender(false)
  }, [render,info?.id])


  const DeclineStatement = async (info, text) => {
    if (otkaz === "") {
      setNotify({
        isOpen: true,
        message: t("statements.info.enter_reject_reason"),
        type: "warning",
        sound: "warning",
      });
    } else {
      try {
        setLoader(true);
        let newStatement = {
          addressee: info.addressee,
          applicationmember: info.applicationmember,
          type: info.type,
          status: text,
          prich_pr_otkaz: otkaz,
        };

        let response = await SignRaport(info.id, newStatement);

        dispatch(setSignStatement(response.data));
        setNotify({
          isOpen: true,
          message: t("statements.info.report_rejected"),
          type: "success",
          sound: "success",
        });
        setRender(true);
        setState2({ isPaneOpen2: false });
        navigate('/statements/', { state: { usedId: 6, key: Math.random() } })
      } catch (err) {
      } finally {
        setLoader(false);
      }
    }
  };

  const AcquaintedStatement = async (info, text) => {
    if (otkaz === "") {
      setNotify({
        isOpen: true,
        message: t("statements.info.enter_applicant_comment"),
        type: "warning",
        sound: "warning",
      });
    } else {
      try {
        setLoader(true);
        let newStatement = {
          addressee: info.addressee,
          applicationmember: info.applicationmember,
          type: info.type,
          status: text,
          prich_pr_otkaz: otkaz,
        };
        const modifedFile = await AddWaterMark({
          name: user.lastName ? `${user.surName}.${user.firstName?.split('')[0]}.${user.lastName?.split('')[0]}` : `${user.surName}.${user.firstName?.split('')[0]}`,

          type: info.type,
          count_turn: 0,
          file: info.file,
        });
        let SignStatementFile = {
          addressee: info.addressee,
          status: text,
          file: modifedFile,
        };

        let response = await SignRaport(info.id, newStatement);
        let response2 = await SignRaportFile(response.data.id, SignStatementFile);

        dispatch(setSignStatement(response.data));
        setNotify({
          isOpen: true,
          message: t("statements.info.acquainted"),
          type: "success",
          sound: "success",
        });

        setRender(true);
        setState2({ isPaneOpen2: false });
        navigate('/statements/', { state: { usedId: 6, key: Math.random() } })
      } catch (err) {
      } finally {
        setLoader(false);
      }
    }
  };
const pinLogIn = async () => {
  if (String(pinCode).length !== 4) {
    setNotify({
      isOpen: true,
      message: t("statements.info.enter_4_digit_pin"),
      type: "error",
    });
    return;
  }

  try {
    const response = await checkPinCode(pinCode, user.userId);
    if (response.data.success) {
      setNotify({
        isOpen: true,
        message: t("statements.info.correct_pin"),
        type: "success",
        sound: "success",
      });
      setPinOrComment(false);
    } else {
      setNotify({
        isOpen: true,
        message: t("statements.info.wrong_pin"),
        type: "error",
      });
    }
  } catch {
    setNotify({
      isOpen: true,
      message: t("common.server_error_retry"),
      type: "error",
    });
  }
};

  const РЎhancelleryStatement = async (info, text) => {
    if (otkaz === "") {
      setNotify({
        isOpen: true,
        message: t("statements.info.enter_chancellery_comment"),
        type: "warning",
        sound: "warning",
      });
    } else {
      let newStatement = {
        addressee: info.addressee,
        applicationmember: info.applicationmember,
        type: info.type,
        status: text,
        prich_pr_otkaz: otkaz,
      };

      let response = await SignRaport(info.id, newStatement);

      dispatch(setSignStatement(response.data));
      setNotify({
        isOpen: true,
        message: t("statements.info.sent_to_chancellery"),
        type: "success",
        sound: "success",
      });

      setRender(true);
      setState2({ isPaneOpen2: false });
      navigate('/statements/', { state: { usedId: 6, key: Math.random() } })
    }
  };

  const ReSendStatement = async (info) => {
    if (newAdresseId === user.userId) {
      setNotify({
        isOpen: true,
        message: t("statements.info.addressee_is_user"),
        type: "warning",
        sound: "warning",
      });
    } else if (newAdresseId === info?.employee.user) {
      setNotify({
        isOpen: true,
        message: t("statements.info.addressee_is_creator"),
        type: "warning",
        sound: "warning",
      });
    } else {
      try {
        setLoader(true);
        let newStatement = {
          addressee: newAdresseId,
          applicationmember: info.applicationmember,
          type: info.type,
          status: "РџРµСЂРµРґР°С‚СЊ",
        };

        let response = await SignRaport(info.id, newStatement);

        dispatch(setSignStatement(response.data));
        setNotify({
          isOpen: true,
          message: t("statements.info.report_resent"),
          type: "success",
          sound: "success",
        });
        setOpenModal(false);
        setRender(true);
        setNewAdresseId(null);
        navigate('/statements/', { state: { usedId: 6, key: Math.random() } })
      } catch (err) {
      } finally {
        setLoader(false);
      }
    }
  };

  const handleChange = () => {
    setState({ isPaneOpen: true, isTask: true })

  }


  const handleView = () => {
    setMenuPreview(true)
    setMenuPreviewCard(false)
    setMenuPreviewTask(false)
  }
  const handleViewCard = () => {
    setMenuPreview(false)
    setMenuPreviewCard(true)
    setMenuPreviewTask(false)
  }
  const handleViewTask = () => {
    setMenuPreview(false)
    setMenuPreviewCard(false)
    setMenuPreviewTask(true)
  }
  const buttons = [
    { handler: handleView, icon: eyeIcon, active: menu_preview },
    { handler: handleViewCard, icon: documentIcon, active: menu_previewCard },
    { handler: handleViewTask, icon: Task, active: menu_previewTask }
  ];

  {
    buttons.map((button, index) => (
      <button
        key={index}
        onClick={button.handler}
        style={{ backgroundColor: button.active ? 'white' : undefined }}
        className={styles.menu_btn}
      >
        <img style={{ height: '47%', filter: button.icon === Task ? 'invert(1)' : undefined }} src={button.icon} alt="" />
      </button>
    ))
  }


  return (
    <div>

      <div className={styles.simple_raports_wrapper}>
        <div className={styles.simple_raports_info_wrapper}>
          <div className={styles.simple_raports_info_header}>
            {width > 1100 ? (
              <>
              
                <img
                  src={close}
                  style={{
                    width: "25px",
                    height: "25px",
                    cursor: "pointer",
                    marginTop: "20px",
                  }}
                  alt=""
                  onClick={() => navigate(`/statements/`, { state: { usedId: 6, key: Math.random() } })}
                />


              </>
            ) : (
              <>
              
                <img
                  src={back}
                  onClick={() => navigate(-1)}
                  className={styles.size}
                  alt="s"
                />


              </>
            )}
          </div>
          <div>
            <div className={styles.simple_raports_info_heading}>
              <div className={styles.left}>
                
                <h3 style={{ color: 'darkblue', fontWeight: 'bold', fontSize: '20px', }}> {info.type} <span style={{ color: 'darkgrey', fontWeight: '500', fontSize: '16px', }}>{t('statements.info.from_label')} {info?.date_zayavki}</span></h3>
                <p className={styles.text} style={{ fontSize: '16px', }} >{"       " + info.text}</p>
                <p>{t('statements.info.status_label')}: {info.status}</p>
              </div>

            </div>
            {info.status === "РћС‚РєР°Р·Р°РЅРѕ" && info.prich_pr_otkaz != null ? (
              <div className={styles.simple_raports_info_heading}>
                <h2>{t('statements.info.reject_reason_label')}: {info.prich_pr_otkaz} </h2>
              </div>
            ) : null}


          </div>


          <div className={styles.menu_preview}>
            {buttons.map((button, index) => (
              <button
                key={index}
                onClick={button.handler}
                style={{ backgroundColor: button.active ? 'white' : undefined }}
                className={styles.menu_btn}
              >
                <img style={{ height: '47%', filter: button.icon === Task ? 'invert(1)' : undefined }} src={button.icon} alt="" />
              </button>
            ))}

          </div>
          <div style={{ display: 'flex', justifyContent: 'end', marginRight: '10px' }}>

            {!info?.file && menu_preview ? <img
              src={printer}
              style={{
                width: "35px",
                height: "35px",
                cursor: "pointer",
                marginTop: "20px",
              }}
              alt=""
              onClick={handlePrint}
            /> : null}
          
          </div>
          <div>
            {menu_preview ? width > 1300 ? (
              <div className={styles.simple_raports_wrapper}>
                {info?.file !== null && info?.file?.includes(".pdf") ? (
                  <PdfPreview file={info.file} />

                ) :


                  <>  <div
                    ref={componentRef}
                    style={{
                      width: '795px',  
                      backgroundColor: 'var(--color-bg)', 
                      margin: '0 auto', 
                      overflowX: 'auto',
                      padding: '40px'
                    }}
                  >
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>

                      <div className={styles.left}>
                        <p>{t('statements.info.doc_number_label')}: {info.number} </p>
                        <p>{t('statements.info.status_label')}: {info.status}</p>
                        <p>{t('statements.info.subject_label')}: {info.type}</p>
                      </div>
                      <div className={styles.right}>
                        <p>{info.prorector}</p>
                        <p>{t('statements.info.from_label')}</p>
                        <p>
                          {info.employee?.surname} {info.employee?.first_name}
                        </p>
                      </div>
                    </div>

                    <div className={styles.simple_raports_info_body}>
                      <h1>{info?.type_doc}</h1>
                      <div className={styles.simple_raports_info_discrip}>
                        <p>{info.text}</p>
                      </div>
                      <div className={styles.simple_raports_info_discrip}>

                        <div className={styles.simple_rapoirts_user_sign}>
                          <p>
                            {info.employee?.surname} {info.employee?.first_name}{" "}
                            {info.date_zayavki}
                            {info.ispolnpodcheck && (
                              <div className={styles.user_sign}>
                                {info.ispolnpodcheck.includes("РћС‚РєР°Р·Р°РЅРѕ") ? (
                                  <p className={styles.text_sign}>
                                    {t('statements.info.applicant_sign')}: <br />
                                    {t('statements.info.rejected')}{" "}
                                  </p>
                                ) : (
                                  <p>
                                    {t('statements.info.applicant_sign')}: <br /> <br />{" "}
                                  </p>
                                )}
                                <div>
                                  <img style={{ width: '130px' }} src={info.ispolnpodsign} alt="" />
                                </div>
                              </div>
                            )}
                            <div className={styles.simple_raports_info_body}>


                              {info.status === "РћС‚РєР°Р·Р°РЅРѕ" && info.prich_pr_otkaz != null ? (
                                <div className={styles.simple_raports_info_heading}>
                                  <h2>{t('statements.info.reject_reason_label')}: {info.prich_pr_otkaz} </h2>
                                </div>
                              ) : info.status === "РћР·РЅР°РєРѕРјР»РµРЅ" &&
                                info.prich_pr_otkaz != null ? (
                                <div className={styles.simple_raports_info_heading}>
                                  <h2>{t('statements.info.acquaint_comment_label')}: {info.prich_pr_otkaz} </h2>
                                </div>
                              ) : info.status === "Р’ РєР°РЅС†РµР»СЏСЂРёРё" &&
                                info.prich_pr_otkaz != null ? (
                                <div className={styles.simple_raports_info_heading}>
                                  <h2>{t('statements.info.chancellery_comment_label')}: {info.prich_pr_otkaz} </h2>
                                </div>
                              ) : (
                                ""
                              )}
                              <div className={styles.all_checks}>
                                {info.prorectorcheck && (
                                  <div>
                                    {info.prorectorcheck.includes("РћС‚РєР°Р·Р°РЅРѕ") ? (
                                      <p className={styles.text_sign}>
                                        {t('statements.info.applicant_sign')}: <br />
                                        {t('statements.info.rejected')}{" "}
                                      </p>
                                    ) : (
                                      <p>
                                        {t('statements.info.signature_of')} {info.prorector_name}: <br />{" "}
                                        {info.prorector_date_check} <br />{" "}
                                      </p>
                                    )}
                                    <div>
                                      <img src={info.prorectorsign} alt="" />
                                    </div>
                                  </div>
                                )}

                                {info.applicationmember?.map((item) => {
                                  return (
                                    <div >

                                      <DocumentImgSigns
                                        signer_name={item.name}
                                        signer_sign={item.sign}
                                        signer_sign_time={item.date_check_member}
                                        signer_type={item.name_approval}
                                      />
                                    </div>
                                  );
                                })}
                              </div>
                            </div>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div> </>

                }
              </div>
            ) : (
              <div style={{ overflowX: 'auto' }} className={styles.simple_raports_wrapper}>
                {info?.file !== null && info?.file?.includes(".pdf") ? (
                  <div style={{display:"flex", flexDirection:"column", gap:'20px'}}>
                  <PdfPreview file={info.file} />
                  <FileBlock file_url={info?.file} />
                  </div>
                ) :

                  <>  <div
                    ref={componentRef}
                    style={{
                      width: '795px',

                      backgroundColor: 'var(--color-bg)',
                      margin: '0 auto',
                      overflowX: 'auto',

                      padding: '40px'
                    }}
                  >
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>

                      <div className={styles.left}>
                        <p>{t('statements.info.doc_number_label')}: {info.number} </p>
                        <p>{t('statements.info.status_label')}: {info.status}</p>
                        <p>{t('statements.info.subject_label')}: {info.type}</p>
                      </div>
                      <div className={styles.right}>
                        <p>{info.prorector}</p>
                        <p>{t('statements.info.from_label')}</p>
                        <p>
                          {info.employee?.surname} {info.employee?.first_name}
                        </p>
                      </div>
                    </div>

                    <div className={styles.simple_raports_info_body}>
                      <h1>{info?.type_doc}</h1>
                      <div className={styles.simple_raports_info_discrip}>
                        <p>{info.text}</p>
                      </div>
                      <div className={styles.simple_raports_info_discrip}>

                        <div className={styles.simple_rapoirts_user_sign}>
                          <p>
                            {info.employee?.surname} {info.employee?.first_name}{" "}
                            {info.date_zayavki}
                            {info.ispolnpodcheck && (
                              <div className={styles.user_sign}>
                                {info.ispolnpodcheck.includes("РћС‚РєР°Р·Р°РЅРѕ") ? (
                                  <p className={styles.text_sign}>
                                    {t('statements.info.applicant_sign')}: <br />
                                    {t('statements.info.rejected')}{" "}
                                  </p>
                                ) : (
                                  <p>
                                    {t('statements.info.applicant_sign')}: <br /> <br />{" "}
                                  </p>
                                )}
                                <div>
                                  <img style={{ width: '130px' }} src={info.ispolnpodsign} alt="" />
                                </div>
                              </div>
                            )}
                            <div className={styles.simple_raports_info_body}>


                              {info.status === "РћС‚РєР°Р·Р°РЅРѕ" && info.prich_pr_otkaz != null ? (
                                <div className={styles.simple_raports_info_heading}>
                                  <h2>{t('statements.info.reject_reason_label')}: {info.prich_pr_otkaz} </h2>
                                </div>
                              ) : info.status === "РћР·РЅР°РєРѕРјР»РµРЅ" &&
                                info.prich_pr_otkaz != null ? (
                                <div className={styles.simple_raports_info_heading}>
                                  <h2>{t('statements.info.acquaint_comment_label')}: {info.prich_pr_otkaz} </h2>
                                </div>
                              ) : info.status === "Р’ РєР°РЅС†РµР»СЏСЂРёРё" &&
                                info.prich_pr_otkaz != null ? (
                                <div className={styles.simple_raports_info_heading}>
                                  <h2>{t('statements.info.chancellery_comment_label')}: {info.prich_pr_otkaz} </h2>
                                </div>
                              ) : (
                                ""
                              )}
                              <div className={styles.all_checks}>
                                {info.prorectorcheck && (
                                  <div>
                                    {info.prorectorcheck.includes("РћС‚РєР°Р·Р°РЅРѕ") ? (
                                      <p className={styles.text_sign}>
                                        {t('statements.info.applicant_sign')}: <br />
                                        {t('statements.info.rejected')}{" "}
                                      </p>
                                    ) : (
                                      <p>
                                        {t('statements.info.signature_of')} {info.prorector_name}: <br />{" "}
                                        {info.prorector_date_check} <br />{" "}
                                      </p>
                                    )}
                                    <div>
                                      <img src={info.prorectorsign} alt="" />
                                    </div>
                                  </div>
                                )}

                                {info.applicationmember?.map((item) => {
                                  return (
                                    <div >

                                      <DocumentImgSigns
                                        signer_name={item.name}
                                        signer_sign={item.sign}
                                        signer_sign_time={item.date_check_member}
                                        signer_type={item.name_approval}
                                      />
                                    </div>
                                  );
                                })}
                              </div>
                            </div>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div> </>
                }
              </div>
            ) : (null)}

            {menu_previewTask ? (<div style={{ paddingLeft: '28px' }}>
              <h3 style={{ marginBottom: '5px' }}>{t('statements.info.tasks_from_request')} <span></span></h3>
              <ul className={styles.card_list}>

                {info?.tasks?.map((item) => (

                  <li className={styles.card_item}>
                    <p style={{ width: '250px' }}>{item.task_name}</p>
                    <p style={{ cursor: 'pointer' }} onClick={() => navigate(`/task/`, { state: { usedId: item.id, key: Math.random() } })}>{t('statements.info.go_to')}</p>
                  </li>

                ))}


              </ul>
            </div>) : null}

            {menu_previewCard ? (<div style={{ paddingLeft: '28px' }}>
              <h3 style={{ marginBottom: '5px' }}>{t('statements.info.document_card')} <span></span></h3>
              <ul className={styles.card_list}>
                <li className={styles.card_item}>
                  <p style={{ width: '250px' }}>{t('statements.info.doc_type_label')}:</p>
                  <p>{info.type_doc}</p>
                </li>
                <li className={styles.card_item}>
                  <p style={{ width: '250px' }}>{t('statements.info.received_date_label')}:</p>
                  <p>{info.date_zayavki}</p>
                </li>

                <li className={styles.card_item}>
                  <p style={{ width: '250px' }}>{t('statements.info.outgoing_doc_number_label')}:</p>
                  <p>{info.number}</p>
                </li>


              </ul>
              <h3 style={{ marginBottom: '5px' }}>{t('statements.info.outgoing_details')} <span></span></h3>
              <ul className={styles.card_list}>
                <li className={styles.card_item}>
                  <p style={{ width: '250px' }}>{t('statements.info.sender')}</p>
                  <p> {info.employee?.surname} {info.employee?.first_name}    {info.employee?.number_phone} </p>
                </li>
                <li className={styles.card_item}>
                  <p style={{ width: '250px' }}>{t('statements.info.signer')}  </p>
                  <p>{info.prorector}   {info?.number_addressee}</p>
                </li>


              </ul>
            </div>) : null}

            {info?.files?.length === 0 ? (
              ""
            ) : (
              <div
                style={{
                  display: "flex",
                  gap: "10px",
                  marginLeft: "50px",
                  flexWrap: "wrap",
                }}
              >


                {t('statements.info.attachments')}:
                {info?.files?.map((item, index) => (
                  <a
                    style={{ textDecoration: "none" }}
                    href={item?.file}
                    target="_blank"
                    download={`file_${index}.pdf`}
                  >
                    {decodeURI(item?.file).split("/").slice(-1)[0]}
                  </a>
                ))}
              </div>
            )}
          </div>
          <div className={styles.simple_raports_footer}>
            <div className={styles.all_checks}></div>
            {width > 1000 ? (
              <SlidingPaneUtil
                size="900px"
                title={
                  state.isTask
                    ? t('statements.info.new_task_from_report')
                    : t('statements.info.transfer_for_approval')
                }
                state={state}
                setState={setState}
              >
                {" "}
                {state.isTask === true ? (
                  <TaskForm
                    idstatement={info.id}
                    typestatement={info.type}
                    setRender={setRender}
                    setState={setState}
                  />
                ) : (
                  <AgreementForm
                    idstatement={info.id}
                    typestatement={info.type}
                    setRender={setRender}
                    setState={setState}
                  />
                )}
              </SlidingPaneUtil>
            ) : (
              <SlidingPaneUtil
                size="100%"
                title={
                  state.isTask
                    ? t('statements.info.new_task_from_report')
                    : t('statements.info.transfer_for_approval')
                }
                state={state}
                setState={setState}
              >
                {" "}
                <TaskForm
                  idstatement={info.id}
                  typestatement={info.type}
                  setRender={setRender}
                  setState={setState}
                />{" "}
              </SlidingPaneUtil>
            )}

            {pinOrComment ? (
              <ModalWindow
                openModal={state2.isPaneOpen2}
                setOpenModal={setState2.isPaneOpen2}
                modalText={t('statements.info.enter_pin_modal')}
              >
                <>
                  <PinCode setPinCode={setPinCode} passwordVisible={false} />
                  <Button
                    onClick={() => setState2({ isPaneOpen2: false })}
                    className={styles.btn_pin_close}
                  >
                    {" "}
                    {t('common.close')}
                  </Button>
                  <Button onClick={pinLogIn} className={styles.btn_pin}>
                    {t('common.confirm')}
                  </Button>
                </>
              </ModalWindow>
            ) : (
              <ModalWindow
                openModal={state2.isPaneOpen2}
                setOpenModal={setState2.isPaneOpen2}
                modalTitle={
                  state2.isDecline
                    ? t('statements.info.enter_reject_reason')
                    : state2.isAcquaint
                      ? t('statements.info.enter_acquaint_comment')
                      : state2.isРЎhancellery
                        ? t('statements.info.enter_chancellery_comment')
                        : ""
                }
              >
                <div className={styles.decline_form}>
                  <div className={styles.item_flex1}>
                    <div className={styles.input_type3}>
                      <textarea
                        onChange={(e) => setOtkaz(e.target.value)}
                        className={styles.discription_input}
                        placeholder={
                          state2.isDecline
                            ? t('statements.info.reject_reason_ph')
                            : state2.isAcquaint
                              ? t('statements.info.acquaint_comment_ph')
                              : state2.isРЎhancellery
                                ? t('statements.info.chancellery_comment_ph')
                                : ""
                        }
                        required
                      />
                    </div>
                  </div>
                </div>
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <Button
                    onClick={() => setState2({ isPaneOpen2: false })}
                    className={styles.btn_pin_close}
                  >
                    {t('common.close')}
                  </Button>

                  {state2.isDecline ? (
                    <>

                      {loader ?
                        <Spinner size={28} />
                        :
                        <Button
                          onClick={(e) =>
                            DeclineStatement(info, (text = "РћС‚РєР°Р·Р°РЅРѕ"))
                          }
                          className={styles.btn_pin}
                        >
                          {t('common.decline')}
                        </Button>
                      }
                    </>
                  ) : state2.isAcquaint ? (
                    <>
                      {
                        loader ? (
                          <Spinner size={28} />
                        ) : (
                          <Button
                            onClick={(e) =>
                              AcquaintedStatement(info, (text = "РћР·РЅР°РєРѕРјР»РµРЅ"))
                            }
                            className={styles.btn_pin}
                          >
                            {t('common.send')}
                          </Button>
                        )
                      }
                    </>
                  ) : state2.isРЎhancellery ? (
                    <Button
                      onClick={(e) =>
                        РЎhancelleryStatement(info, (text = "Р’ РєР°РЅС†РµР»СЏСЂРёРё"))
                      }
                      className={styles.btn_pin}
                    >
                      {t('common.send')}
                    </Button>
                  ) : (
                    ""
                  )}
                </div>
              </ModalWindow>
            )}

            {isShown === false ? (
              <div>

              </div>
            ) : (
              <div className={styles.simple_raports_footer2}>
                <div>
                  <div className={styles.input_type3}>
                    <textarea
                      onChange={(e) => setOtkaz(e.target.value)}
                      className={styles.discription_input}
                      placeholder={t('statements.info.reject_reason_ph')}
                    />
                  </div>
                </div>
                <div className={styles.mobile_btns}>
                  {loader ?
                    <Spinner size={28} />
                    :
                    <Button
                      className={styles.btn1}
                      onClick={() => {
                        DeclineStatement(info, (text = "РћС‚РєР°Р·Р°РЅРѕ"));
                      }}
                    >
                      {" "}
                      {t('common.decline')}
                    </Button>
                  }
                </div>
              </div>
            )}
          </div>
        </div>

        <DocumentHistory chats={chats} handleChange={handleChange} handleClickDecline={handleClickDecline} handleClickAcquainted={handleClickAcquainted} handleClickReSend={handleClickReSend} history={history} setRender={setRender} typeDoc={t('statements.info.report_doctype')} info={info} />

        <Notification notify={notify} setNotify={setNotify} />
      </div>


      <>
        <ModalWindow
          openModal={openModal}
          setOpenModal={setOpenModal}
          modalTitle={t('chat.select_employee')}
        >
          <div style={{ marginBottom: "10px" }}></div>
          <EmployeeSelectUserId
            selectedEmployee={setNewAdresseId}
            setSelectedEmployeeLabel={setSelectedEmployeeLabel}
            isMulti={false}
          />
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <button
              style={{ paddingInline: "10px", marginLeft: "0" }}
              onClick={() => setOpenModal(false)}
              className={styles.btn_pin_close}
            >
              {t('common.close')}
            </button>
            {
              loader ? (
                <Spinner size={28} />
              ) : (
                <Button
                  onClick={() => ReSendStatement(info)}
                  className={styles.btn_pin}
                >
                  {t('statements.info.transfer')}
                </Button>
              )
            }
          </div>
        </ModalWindow>{" "}
      </>
    </div>
  );
};

export default SimpleRaports;
